import { render, staticRenderFns } from "./ListaAtributos.vue?vue&type=template&id=792e1a66&scoped=true&"
import script from "./ListaAtributos.vue?vue&type=script&lang=js&"
export * from "./ListaAtributos.vue?vue&type=script&lang=js&"
import style0 from "./ListaAtributos.vue?vue&type=style&index=0&id=792e1a66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792e1a66",
  null
  
)

export default component.exports